class BBSCollectionPagination {
  constructor() {
    this.grid = document.getElementById('bbs-product-grid');
    this.container = document.getElementById('BBSProductGridContainer');
    this.sectionId = this.container?.dataset.sectionId;
    this.pagination = document.querySelector('[data-bbs-pagination]');
    this.button = document.querySelector('[data-bbs-show-more]');
    this.isLoading = false;
    this.defaultLabel = this.button?.textContent?.trim() || 'Show More';

    this.button?.addEventListener('click', () => this.loadMore());
  }

  async loadMore() {
    if (this.isLoading || !this.button?.dataset.nextUrl || !this.grid || !this.sectionId) return;

    const loadedPageUrl = new URL(this.button.dataset.nextUrl, window.location.origin);
    this.setLoading(true);

    try {
      const fetchUrl = new URL(loadedPageUrl);
      fetchUrl.searchParams.set('section_id', this.sectionId);

      const response = await fetch(fetchUrl.toString());
      if (!response.ok) {
        throw new Error(`Failed to load more products (${response.status})`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newItems = doc.querySelectorAll('#bbs-product-grid .bbs-product-grid__item');

      newItems.forEach((item) => {
        const node = document.importNode(item, true);
        this.grid.appendChild(node);
        const card = node.querySelector('[data-bbs-product-card]');
        if (card) {
          window.BBSInitProductCards?.(node);
        }
      });

      window.BBSFavourites?.applyToPage();
      if (sessionStorage.getItem('bbs-show-favourites') === 'true') {
        window.BBSFavourites?.filterGrid(true);
      }

      const nextButton = doc.querySelector('[data-bbs-show-more]');
      if (nextButton?.dataset.nextUrl) {
        this.button.dataset.nextUrl = nextButton.dataset.nextUrl;
        this.setLoading(false);
      } else {
        this.pagination?.remove();
        this.button = null;
      }

      history.pushState({}, '', `${loadedPageUrl.pathname}${loadedPageUrl.search}`);
    } catch (error) {
      console.error(error);
      this.setLoading(false);
    }

    this.isLoading = false;
  }

  setLoading(isLoading) {
    if (!this.button) return;
    this.button.disabled = isLoading;
    this.button.classList.toggle('is-loading', isLoading);
    this.button.textContent = isLoading ? 'Loading...' : this.defaultLabel;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BBSCollectionPagination();
});
